import { getText, get } from '../../helpers';

function removeLastComma(string: string) {
    const n = string.lastIndexOf(',');
    return n > -1 && (n + 1) === string.length ? string.substring(0, n) : string;
}

function getPointInTimeDescription(item: any, localeCode: string) {
    const localizedKey = localeCode === 'en' ? 'PointInTimeDescription' : `PointInTimeDescription_${localeCode}`;
    const localizedValue = get(item, localizedKey, null);
    const keyToUse = localizedValue === null ? 'PointInTimeDescription' : localizedKey;
    return get(item, keyToUse, '');
}

const mapSearchResultToDataProfileCard = (item: DataModal) => {
    const isBundle = item.isType === 'Bundle';
    const localeCode = getText('langCode');
    const marketplaceDataProvider = get(item, localeCode === 'en' ? 'MarketplaceDataProvider' : `MarketplaceDataProvider_${localeCode}`, '');
    return {
        name: get(item, localeCode === 'en' ? 'Name' : `Name_${localeCode}`, ''),
        absoluteName: item.Name,
        urlName: item.Name,
        id: isBundle ? Number(item.KeyMarketplaceDatasetBundle) : Number(item.KeyMarketplaceDataset),
        isBundle,
        addedDate: item.MarketplaceDatasetAdded,
        enhancementDate: item.MktPlaceDataSetEnhancementDate,
        shortDescription: get(item, localeCode === 'en' ? 'Description' : `Description_${localeCode}`, ''),
        thumbnailImageFilePath: item.ThumbnailImageFilePath,
        longDescription: get(item, localeCode === 'en' ? 'MarketplaceLongDescription' : `MarketplaceLongDescription_${localeCode}`, ''),
        dataProvider: marketplaceDataProvider && isBundle ? removeLastComma(marketplaceDataProvider.trim()) : marketplaceDataProvider,
        isType: item.isType,
        activeMarketPlaceSearchTag: get(item, localeCode === 'en' ? 'ActiveMarketPlaceSearchTag' : `ActiveMarketPlaceSearchTag_${localeCode}`, ''),
        spgDeliveryPlatform: item.SPGDeliveryPlatform,
        keySPGDeliveryPlatform: item.KeySPGDeliveryPlatform,
        frequency: get(item, localeCode === 'en' ? 'Frequency' : `Frequency_${localeCode}`, ''),
        latency: get(item, localeCode === 'en' ? 'Latency' : `Latency_${localeCode}`, ''),
        primaryEntityType: get(item, localeCode === 'en' ? 'PrimaryEntityType' : `PrimaryEntityType_${localeCode}`, ''),
        geographyCoverage: get(item, localeCode === 'en' ? 'GeographyCoverage' : `GeographyCoverage_${localeCode}`, ''),
        starterQueries: item.StarterQueries,
        coverageCount: item.CoverageCount,
        pointInTimeValue: item.PointInTime,
        historyIntaited: item.EarliestRecord,
        earliestSignificantCoverage: item.EarliestSignificantCoverage,
        keyGeographyTree: item.KeyGeographyTree,
        marketplaceDataProvider: item.MarketplaceDataProvider,
        pointInTimeDescription: getPointInTimeDescription(item, localeCode),
        FormOrder: item.FormOrder || '',
        MarketPlaceSupportDocument: get(item, localeCode === 'en' ? 'MarketPlaceSupportDocument' : `MarketPlaceSupportDocument_${localeCode}`, ''),
        websiteurl: item.websiteurl || '',
    };
};
export default mapSearchResultToDataProfileCard;
